import * as Yup from "yup";

export interface State {
  client: string | null;
  codeSubsidiary: string | null;
  contract: string | null;
  date: string | null;
  time: string | null;
  product: string | null;
  modality: string | null;
  quantity: string | null;
  invoice?: string | null;
  note: string | null;
}

export type Action =
  | {
      type: "set-client";
      value: string | null;
    }
  | {
      type: "set-code-subsidiary";
      value: string | null;
    }
  | {
      type: "set-contract";
      value: string | null;
    }
  | {
      type: "set-date";
      value: string | null;
    }
  | {
      type: "set-time";
      value: string | null;
    }
  | {
      type: "set-product";
      value: string | null;
    }
  | {
      type: "set-modality";
      value: string | null;
    }
  | {
      type: "set-quantity";
      value: string | null;
    }
  | {
      type: "set-invoice";
      value: string | null;
    }
  | {
      type: "set-note";
      value: string | null;
    }
  | {
      type: "set-all";
      value: State;
    };

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case "set-client":
      return { ...state, client: action.value };
    case "set-code-subsidiary":
      return { ...state, codeSubsidiary: action.value };
    case "set-contract":
      return { ...state, contract: action.value };
    case "set-date":
      return { ...state, date: action.value };
    case "set-time":
      return { ...state, time: action.value };
    case "set-modality":
      return { ...state, modality: action.value };
    case "set-product":
      return { ...state, product: action.value };
    case "set-quantity":
      return { ...state, quantity: action.value };
    case "set-invoice":
      return { ...state, invoice: action.value };
    case "set-note":
      return { ...state, note: action.value };
    case "set-all":
      return { ...action.value };
    default:
      return state;
  }
};

export const initialValues = {
  client: "",
  codeSubsidiary: "",
  contract: "",
  date: "",
  time: "",
  product: "",
  modality: "",
  quantity: "",
  invoice: "",
  note: "",
};

export const schemaValidation = () => {
  return Yup.object().shape({
    client: Yup.string().required("Campo obrigatório"),
    codeSubsidiary: Yup.string().required("Campo obrigatório"),
    contract: Yup.string().required("Campo obrigatório"),
    date: Yup.string().required("Campo obrigatório"),
    time: Yup.string().required("Campo obrigatório"),
    product: Yup.string().required("Campo obrigatório"),
    modality: Yup.string().required("Campo obrigatório"),
    quantity: Yup.string().required("Campo obrigatório"),
  });
};
